module.exports = __webpack_public_path__ + "img/bonus6.b98dc52a.png";